import simpleParallax from "simple-parallax-js";

$(function() {
    if (!App.isSSR) {
        var images = document.querySelectorAll('img.parallax');
        new simpleParallax(images, {
            delay: 0.6,
            maxTransition: 100,
            transition: 'cubic-bezier(0,0,0,1)',
        });


        var mainImages = document.querySelectorAll('div.category__teaser-img');
        new simpleParallax(mainImages, {
            delay: 0.6,
            maxTransition: 100,
        });


        var catImages = document.querySelectorAll('div.category__serie-img-tiles img');
        new simpleParallax(catImages, {
            delay: 0.6,
            maxTransition: 100,
        });

        var homeWidget = document.querySelectorAll('.homepage__category-widget img, .homepage-swiper__img');
        new simpleParallax(homeWidget, {
            delay: 0.6,
            maxTransition: 100,
        });
    }
})
